import { Modal } from "@heroui/react";

import { ProductCard } from "../card";

import { Product } from "@/types";

interface ProductViewModalProps {
  isOpen: boolean;
  product: Product | null;
  onClose: () => void;
}

export const ProductViewModal = ({
  product,
  isOpen,
  onClose,
}: ProductViewModalProps) => {
  return (
    <Modal.Backdrop
      isOpen={isOpen}
      variant="opaque"
      onOpenChange={(open) => !open && onClose()}
    >
      <Modal.Container placement="center">
        <Modal.Dialog className="w-full max-w-md">
          <Modal.CloseTrigger />
          <Modal.Header>
            <Modal.Heading>Viewing product</Modal.Heading>
          </Modal.Header>
          <Modal.Body className="p-1">
            {product && <ProductCard product={product} />}
          </Modal.Body>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
};
